import { render, staticRenderFns } from "./AscriptionEdit.vue?vue&type=template&id=12a26e08&scoped=true&"
import script from "./AscriptionEdit.vue?vue&type=script&lang=js&"
export * from "./AscriptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./AscriptionEdit.vue?vue&type=style&index=0&id=12a26e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a26e08",
  null
  
)

export default component.exports